const blbentLogo = '/assets/blbent_logo.png';

function Logo() {
  return (
    <div className="w-24 h-24 flex items-center justify-center rounded-lg overflow-hidden">
      <img src={blbentLogo} alt="BLBENT Logo" className="w-full h-full object-contain" />
    </div>
  );
}

export default Logo;
